/**
 * T-022 — attachments contracts (tasks/W2-CONTRACTS.md §4 — ค่าตรึงตามตัว)
 * `Attachment.url` เป็น path สัมพัทธ์ `/attachments/:id?exp=&sig=` (SPA กับ Worker ที่ production อยู่ origin เดียวกัน)
 */
import { z } from "zod";

export const Attachment = z.object({
  id: z.uuid(),
  filename: z.string(),
  mime: z.string(),
  size: z.number().int(),
  risk_flag: z.boolean(),
  inline_cid: z.string().nullable(),
  ticket_id: z.string().nullable(),
  // [TM-04] แนบกับงานภายใน (migration 0036 attachments.task_id) — response ฝั่ง ticket ไม่ส่ง field นี้ (optional เพื่อ additive)
  task_id: z.string().optional(),
  url: z.string().nullable(),
  created_at: z.iso.datetime(),
});
export type Attachment = z.infer<typeof Attachment>;

export const AttachmentUrl = z.object({
  url: z.string(),
  expires_at: z.iso.datetime(),
});
export type AttachmentUrl = z.infer<typeof AttachmentUrl>;
